<mat-card fxLayout="column">
  <h2 translate>requestFinanceMg.title</h2>
  <div *ngIf="hasAnyFinancing(); else showNoFinancing">
    <form [formGroup]="financeForm">
      <div class="table__wrapper">
        <table aria-label="request-finance-mg" mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="percentageDiscount">
            <th mat-header-cell *matHeaderCellDef translate>requestFinance.percentageDiscount</th>
            <td mat-cell *matCellDef="let element">{{ element.discountPercentage }} %</td>
          </ng-container>
          <ng-container matColumnDef="percentageWelcome">
            <th mat-header-cell *matHeaderCellDef translate>requestFinance.percentageWelcome</th>
            <td mat-cell *matCellDef="let element">{{ element.discountWelcome }} €</td>
          </ng-container>
          <ng-container matColumnDef="netPursacheAmount">
            <th mat-header-cell *matHeaderCellDef translate>requestFinance.netPursacheAmount</th>
            <td mat-cell *matCellDef="let element">{{ element.netPurchaseAmount }} €</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </form>
  </div>

  <ng-template #showNoFinancing>
    <div fxLayout="column" fxLayoutAlign="center center">
      <mat-label translate>requestFinance.noFinancing</mat-label>
      <mat-label translate>requestFinance.validationEntries</mat-label>
    </div>
  </ng-template>
</mat-card>
